import { useReducer } from 'react';

type ModalState<K extends string, M extends Record<K, unknown>> = {
  activeModal: K | null;
  payload?: M[keyof M];
};

type ModalAction<M> =
  | {
      type: keyof M;
      payload?: M[keyof M] extends undefined ? never : M[keyof M];
    }
  | { type: 'CLOSE_MODAL' };

const modalReducer = <K extends string, M extends Record<K, unknown>>(
  state: ModalState<K, M>,
  action: ModalAction<M>
): ModalState<K, M> => {
  if (action.type === 'CLOSE_MODAL') {
    return { activeModal: null };
  }

  const { type, payload } = action as Exclude<
    ModalAction<M>,
    { type: 'CLOSE_MODAL' }
  >;
  return {
    activeModal: type as K,
    payload,
  };
};

export const useModal = <K extends string, M extends Record<K, unknown>>(
  initialState: ModalState<K, M>
) => {
  return useReducer(modalReducer<K, M>, initialState);
};
